import { SERVICE_URL } from "../config";

export const CSRF_TOKEN_COOKIE_NAME = "csrf_token";
export const SESSION_COOKIE_NAME = "session_id";
export const CONTACT_EMAIL = "help-marusf@asan-nanum.org";
export const PRIVACY_POLICY_URL = `${SERVICE_URL}/privacy_policy`;
